import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function KimiIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="60" height="60" viewBox="0 0 60 60" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.345 14.44C49.7525 13.9175 50.11 13.44 50.4875 12.9775C50.6625 12.76 50.6475 12.595 50.4775 12.3675C48.84 10.215 48.685 7.82499 49.6275 5.39999C50.335 3.57499 51.9 2.71999 53.8125 2.53749C55.005 2.42499 56.175 2.54749
        57.26 3.12749C58.685 3.88999 59.515 5.05249 59.785 6.65749C60 7.93749 59.96 9.18749 59.5975 10.4275C58.955 12.6225 57.3775 13.76 55.215 14.0475C53.42 14.2875 51.6 14.3175 49.79 14.44C49.65 14.45 49.5075 14.44 49.345 14.44Z"
        fill="#027AFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.905 4.60999H34.09L25.5275 24.135H13.4225V4.69499H3.75V55H13.425V33.8075H30.485C31.9261 33.8074 33.3372 33.3956 34.5521 32.6205C35.767 31.8454 36.7351 30.7393 37.3425 29.4325V55H47.0175V33.8075C47.0177 31.3634 46.0929 29.0099
        44.4289 27.2197C42.7649 25.4296 40.4851 24.3356 38.0475 24.1575V24.1325H32.735C34.0151 23.6952 35.1913 22.9989 36.1905 22.0871C37.1896 21.1752 37.9903 20.0673 38.5425 18.8325L44.905 4.60999Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default KimiIcon;
